window.Products.DeviceCase.GalaxyS3 = function() {
};
window.Products.DeviceCase.GalaxyS3.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS3.id = 3;
window.Products.DeviceCase.GalaxyS3.slug = 'galaxy-s3';